module.exports = __webpack_public_path__ + "static/media/20.c4784cc4.png";